export const SUPABASE_URL = "https://ryeepwrvrgieskpxarsz.supabase.co";

export const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ5ZWVwd3J2cmdpZXNrcHhhcnN6Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE3OTg2MzUsImV4cCI6MjA3NzM3NDYzNX0.RFQMDbNRH2DPrxqbKhOF8oRW9og8A-F2DmcIOLrNeDE";
